export default __webpack_public_path__ + "static/media/checkmark.ecd0e319.svg";